import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";
import {ReleaseEstimateFromPendingParams} from "../types/ReleaseEstimateFromPendingParams";

export const useReleaseEstimateFromPending = (
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async (params: ReleaseEstimateFromPendingParams) => {
			return await apiClient.post("estimate/release-from-pending", params) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when releasing the lead/estimate from pending status: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
